import { ofType } from 'redux-observable';
import { exhaustMap } from 'rxjs/operators';

import { fetchCardAccountApplication } from '@perpay-web/fintech/actions/entities/cardAccountApplications';
import { fetchFeatures } from '@perpay-web/fintech/actions/entities/features';
import { fetchUserInfo } from '@perpay-web/fintech/actions/entities/userInfo';
import { fetchUserStatus } from '@perpay-web/fintech/actions/entities/userStatus';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import {
    fetchCardActivation as fetchCardActivationAction,
    fetchCardActivationSuccess,
    fetchCardActivationError,
} from '@perpay-web/fintech/actions/ui/cardActivation';
import {
    STORE_FETCH_FEATURES_ERROR,
    STORE_REPLACE_FEATURES,
    STORE_REPLACE_USER_STATUS,
    STORE_REPLACE_USER_STATUS_ERROR,
} from '@perpay-web/fintech/constants/actionTypes';
import { CARD_ACTIVATE } from '@perpay-web/fintech/constants/featureDetails';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { getCardFeatureDetails } from '@perpay-web/fintech/selectors/entities/features';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export const fetchCardActivation = (action$, state$) =>
    action$.pipe(
        ofType(fetchCardActivationAction().type),
        exhaustMap(() =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: () => [
                    fetchUserStatus(),
                    fetchFeatures(),
                    fetchUserInfo(),
                    fetchCardAccountApplication(),
                ],
                waitFor: [STORE_REPLACE_USER_STATUS, STORE_REPLACE_FEATURES],
                waitForDispatch: (state) => {
                    const cardFeatureDetails = getCardFeatureDetails(state);

                    const maybeRedirectAction = !cardFeatureDetails.includes(
                        CARD_ACTIVATE,
                    )
                        ? [
                              routeToLocation({
                                  path: paths.dashboard.path,
                                  replace: true,
                              }),
                          ]
                        : [];

                    return [
                        ...maybeRedirectAction,
                        fetchCardActivationSuccess(),
                    ];
                },
                errors: [
                    STORE_FETCH_FEATURES_ERROR,
                    STORE_REPLACE_USER_STATUS_ERROR,
                ],
                errorDispatch: () => [
                    routeToLocation({
                        path: paths.dashboard.path,
                        replace: true,
                    }),
                    fetchCardActivationError(),
                ],
            }),
        ),
    );
